import React from 'react';
import { TransactionType } from '../utils/enums';

const TransactionsHeader = ({ transactions, collapsed, onToggle, onAdd }) => {
  const safeTxs = Array.isArray(transactions) ? transactions : [];
  const visibleTxs = safeTxs.filter(tx => tx?.hidden !== true);

  const txCounts = {
    [TransactionType.BUY]: 0,
    [TransactionType.SELL]: 0,
    [TransactionType.TRANSFER_IN]: 0,
    [TransactionType.TRANSFER_OUT]: 0,
    [TransactionType.SPLIT]: 0
  };

  visibleTxs.forEach(tx => {
    const txType = tx.transactionType?.toUpperCase?.() || tx.transactionType;
    if (txCounts[txType] !== undefined) {
      txCounts[txType]++;
    }
  });

  const visibleTxCount = (
    (txCounts[TransactionType.BUY] || 0) +
    (txCounts[TransactionType.SELL] || 0) +
    (txCounts[TransactionType.TRANSFER_IN] || 0) +
    (txCounts[TransactionType.TRANSFER_OUT] || 0) +
    (txCounts[TransactionType.SPLIT] || 0)
  );

  const renderNonZeroTxCounts = () => {
    const parts = [];
    if (txCounts[TransactionType.SPLIT] > 0) {
      parts.push(<span key="split" className={TransactionType.getTypeColor(TransactionType.SPLIT)}>{txCounts[TransactionType.SPLIT]} split</span>);
    }
    if ((txCounts[TransactionType.BUY] || 0) > 0) {
      parts.push(
        <span key="buy" className={TransactionType.getTypeColor(TransactionType.BUY)} title="Buy transactions">
          {txCounts[TransactionType.BUY]} buy
        </span>
      );
    }
    if ((txCounts[TransactionType.SELL] || 0) > 0) {
      parts.push(
        <span key="sell" className={TransactionType.getTypeColor(TransactionType.SELL)} title="Sell transactions">
          {txCounts[TransactionType.SELL]} sell
        </span>
      );
    }
    if ((txCounts[TransactionType.TRANSFER_IN] || 0) > 0) {
      parts.push(
        <span key="in" className={TransactionType.getTypeColor(TransactionType.TRANSFER_IN)} title="Transfer In transactions">
          {txCounts[TransactionType.TRANSFER_IN]} in
        </span>
      );
    }
    if ((txCounts[TransactionType.TRANSFER_OUT] || 0) > 0) {
      parts.push(
        <span key="out" className={TransactionType.getTypeColor(TransactionType.TRANSFER_OUT)} title="Transfer Out transactions">
          {txCounts[TransactionType.TRANSFER_OUT]} out
        </span>
      );
    }
    const interleaved = [];
    parts.forEach((part, idx) => {
      if (idx > 0) interleaved.push(<span key={`sep-${idx}`} className="mx-1">/</span>);
      interleaved.push(part);
    });
    return interleaved;
  };

  return (
    <div 
      className="flex justify-between items-center py-2 px-3 bg-gray-100 dark:bg-gray-800 border-b border-gray-200 dark:border-gray-600 cursor-pointer"
      onClick={onToggle}
    >
      <h2 className="font-semibold text-base">
        Transactions
        {visibleTxCount > 0 && (
          <span className="text-sm font-normal ml-2">
            {visibleTxCount} (
            {renderNonZeroTxCounts()}
            )
          </span>
        )}
      </h2>
      <div className="flex items-center space-x-2">
        <button
          onClick={(e) => { e.stopPropagation(); onAdd && onAdd(); }}
          className="bg-blue-500 hover:bg-blue-700 text-white text-xs font-semibold py-1 px-2 rounded"
        >
          Add
        </button>
        <button onClick={(e) => { e.stopPropagation(); onToggle && onToggle(); }} className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200">
        {collapsed ? (
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
          </svg>
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z" clipRule="evenodd" />
          </svg>
        )}
        </button>
      </div>
    </div>
  );
};

export default TransactionsHeader;


